import type { AccountId, RefObject } from '@atlassian/jira-shared-types/src/general.tsx';
import type {
	INVALID_PATTERN_PROJECT_KEY_ERROR,
	REQUIRED_PROJECT_KEY_ERROR,
	TOO_LONG_PROJECT_KEY_ERROR,
	TOO_LONG_PROJECT_NAME_ERROR,
	TOO_SHORT_PROJECT_NAME_ERROR,
	PROJECT_TEAM_TYPE_FREE_TEXT_ERROR,
	PROJECT_KEY_CHANGE_WARNING,
	TOO_LONG_PROJECT_URL_ERROR,
	INVALID_URL_PATTERN,
} from '../../model/constants';
import type { AvatarDetails, AssigneeType } from '../../model/types';

export type ValidationMessageType = 'info' | 'warning' | 'error';

export const MESSAGE_TYPE_ERROR: ValidationMessageType = 'error';

export const MESSAGE_TYPE_WARNING: ValidationMessageType = 'warning';

export type ValidationMessageKeyType =
	| typeof TOO_SHORT_PROJECT_NAME_ERROR
	| typeof TOO_LONG_PROJECT_NAME_ERROR
	| typeof TOO_LONG_PROJECT_URL_ERROR
	| typeof PROJECT_TEAM_TYPE_FREE_TEXT_ERROR
	| typeof REQUIRED_PROJECT_KEY_ERROR
	| typeof TOO_LONG_PROJECT_KEY_ERROR
	| typeof INVALID_PATTERN_PROJECT_KEY_ERROR
	| typeof INVALID_URL_PATTERN
	| typeof PROJECT_KEY_CHANGE_WARNING;

type ValidationMessageFromClient = {
	type: ValidationMessageType;
	key: ValidationMessageKeyType;
};

type ValidationMessageFromServer = {
	type: ValidationMessageType;
	body: string;
};

export type ValidationMessage =
	| ValidationMessageFromClient
	| ValidationMessageFromServer
	| undefined;

export type ValidationErrors = {
	projectName: ValidationMessage;
	projectKey: ValidationMessage;
	projectUrl: ValidationMessage;
	projectTeamTypeFreeText: ValidationMessage;
	releaseProjectKeysError: ValidationMessage;
};

export type FlagType =
	| 'SUBMIT_SUCCESS_FLAG'
	| 'RELEASE_KEYS_ERROR'
	| 'UPLOAD_AVATAR_SUCCESS_FLAG'
	| 'GENERIC_ERROR_FLAG'
	| 'DELETE_PROJECT_SUCCESS_FLAG'
	| 'DELETE_PROJECT_FAIL_FLAG'
	| 'AVATAR_FETCH_FAIL_FLAG'
	| 'AVATAR_UPLOAD_FAIL_FLAG';

export const SUBMIT_SUCCESS_FLAG: FlagType = 'SUBMIT_SUCCESS_FLAG';
export const RELEASE_KEYS_ERROR: FlagType = 'RELEASE_KEYS_ERROR';
export const GENERIC_ERROR_FLAG: FlagType = 'GENERIC_ERROR_FLAG';
export const DELETE_PROJECT_SUCCESS_FLAG: FlagType = 'DELETE_PROJECT_SUCCESS_FLAG';
export const DELETE_PROJECT_FAIL_FLAG: FlagType = 'DELETE_PROJECT_FAIL_FLAG';
export const AVATAR_FETCH_FAIL_FLAG: FlagType = 'AVATAR_FETCH_FAIL_FLAG';
export const AVATAR_UPLOAD_FAIL_FLAG: FlagType = 'AVATAR_UPLOAD_FAIL_FLAG';

export type Flag = {
	id: string;
	type: FlagType;
};

export type UIState = {
	isDeleteProjectModalOpen: boolean;
	isDeleting: boolean;
	isLoading: boolean;
	isSubmitting: boolean;
	isAvatarPickerDialogOpen: boolean;
	isUploadingAvatar: boolean;
	isAvatarImageLoaded: boolean;
	validationErrors: ValidationErrors;
	flags: Flag[];
	projectName: string;
	projectKey: string;
	historicalProjectKeys: string[];
	projectUrl: string;
	projectDescription: string;
	simplified: boolean;
	projectCategoryId?: string;
	projectLeadAccountId: AccountId;
	assigneeType: AssigneeType;
	avatar?: AvatarDetails;
	isTrashProjectModalOpen: boolean;
	isArchiveProjectModalOpen: boolean;
	forceValidationFor: string | undefined;
	projectNameMaxLength: number | undefined;
	projectKeyMaxLength: number | undefined;
	allowUnassigned: boolean | undefined;
	projectTeamType: string | undefined;
	projectTeamTypeFreeText: string | undefined;
	dropDownMenuButtonRef: RefObject | undefined;
	releasedProjectKeys: string[];
};
